module.exports = __webpack_public_path__ + "img/selected0-min.c87a05c2.png";